<template lang="pug">
.personal-info-container
  .personal-info.content
    .item(@click='userInfo')
      span 个人信息
      .icon
    .item(@click='userDown')
      span 个人信息导出
      .icon
  .privacy.content
    .item(@click='abstract')
      span 隐私政策摘要
      .icon
    .item(@click='nonage')
      span 未成年保护
      .icon
    .item(@click='feedback')
      span 隐私问题反馈
      .icon
  .system-permission.content
    .item(@click='permssion')
      span 系统权限管理
      .icon
    .item(@click='clearHistory')
      span 清除历史个性记录
      .icon
  clear-history-modal(:show.sync="historyModal")
</template>

<script>
import { isPreRender, commonGoLink } from '@/utils';
import { env } from '@hb/NBridge/lib/h5';
import config from '@/const/config';
import ClearHistoryModal from './components/clear-history-modal.vue';

export default {
  components: {
    ClearHistoryModal,
  },
  data() {
    return {
      historyModal: false,
      // 导航锁，防止重复点击
      isNavigating: false,
    };
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
    }
  },
  methods: {
    userInfo() {
      if (env.isHelloFamilyApp) {
        window.location.href = 'hellobike://hellobike.com/userPlatform/user_info_list';
      }
    },
    userDown() {
      if (env.isHelloFamilyApp) {
        window.location.href = 'hellobike://hellobike.com/userPlatform/user_info_download';
      }
    },
    abstract() {
      commonGoLink('https://h.c3x.me/1YtUvK', { isRuleLink: true });
    },
    feedback() {
      const url = `https://m.hellobike.com/AppCSSelfServiceH5/${
        config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html#/privacyfb`;
      window.location.href = url;
    },
    permssion() {
      // 如果正在导航中，直接返回
      if (this.isNavigating) {
        return;
      }

      this.isNavigating = true;

      this.$router.push('/system-permission').catch(() => {

      }).finally(() => {
        // 延迟解锁，防止快速重复点击
        setTimeout(() => {
          this.isNavigating = false;
        }, 10);
      });
    },
    nonage() {
      window.location.href = 'https://m.hellobike.com/ebike-h5/latest/article.html?guid=6ffe2be0f12b46fdb86df38944605357';
    },
    clearHistory() {
      this.historyModal = true;
    },
  },
};
</script>

<style lang="less" scoped>
  .personal-info-container {
    min-height: 100vh;
    width: 100%;
    background: #f0f3f5;
    box-sizing: border-box;
    overflow: hidden;

    .content {
      padding: 0 0.16rem;
      background-color: #fff;
      margin-top: 0.12rem;

      .item {
        height: 0.48rem;
        line-height: 0.48rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span:nth-child(1) {
          font-size: 0.14rem;
          font-weight: 400;
          color: #242729;
        }

        .icon {
          width: 0.12rem;
          height: 0.12rem;
          background: url('https://m.hellobike.com/resource/helloyun/wb15250/BRWWH8nhVs.png?x-oss-process=image/quality,q_80') no-repeat top;
          background-size: 100% 100%;
        }
      }

      & .item:not(:last-child) {
        border-bottom: 0.01rem solid #f0f3f5;
      }
    }
  }
</style>
